import { QueryClient } from '@tanstack/react-query';
import { ApiError, shouldRetry } from './http';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry(failureCount, error) {
        if (!shouldRetry(error)) return false;
        return failureCount < 2;
      },
      staleTime: 5_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry(_failureCount, error) {
        // 写操作默认不重试,避免重复下单 / 重复模式切换
        if (error instanceof ApiError && error.code === 'RATE_LIMITED') return _failureCount < 2;
        return false;
      },
    },
  },
});
